import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import CardInfoIcon from '../../components/CardInfoIcon/CardInfoIcon';


const Certifications = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/certifications.json`); 
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        certifications
    } = data

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container mg-bot-100">
                    <PageTitle title={pageTitle} />
                    <div className='container-card-info'>
                        {certifications.map((d, i) => <CardInfoIcon
                            key={i}
                            title={d.title}
                            content={d.content}
                            iconName={d.iconName}
                            iconWidth={d.iconWidth}
                            iconHeight={d.iconHeight}
                            iconMargin={d.iconMargin}
                        />)}
                    </div>

                </section>
            </div>
        </>
    )
}

export default Certifications